import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Container from '@mui/material/Container';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispachToProps } from "../../store/MapToProps";
import Loader from '../common/loder'

import axios from 'axios';
const URL = process.env.REACT_APP_API_URL;



function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="#">
        Vendoapp
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const checkLocalStorage = () => {
  return localStorage.getItem("uid") ? true : false;
};

const useStyles = makeStyles(() => ({
  paper: {
    marginTop: "8em !important",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: "1em !important",
    backgroundColor: "#f50057 !important",
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: "1em !important",
  },
  submit: {
    margin: '1em 0 1em 0 !important',
  },
}));

const Login = (props) => {
  const [open, setOpen] = useState(false);
  const [uname, setUname] = useState("");
  const [password, setPassword] = useState("");
  const [personName, setPersonName] = useState("admin");
  const classes = useStyles();


  const handlePost = (body, endpoint, person) => {
    props.enableLoder()
    axios.post(`${URL}${endpoint}`, body)
      .then(res => {
        let data = res.data
        if (data.status) {
          props.disableLoder()
          const expr = (new Date()).getTime() + (2 * 60 * 1000)
          localStorage.setItem("expr", expr);
          switch (person) {
            case "admin":
              localStorage.setItem("priority", 1);
              localStorage.setItem("uid", JSON.stringify(data.result));
              setTimeout(() => {
                window.location = "/dashboard"
              }, 2000)
              break
            case "provider":
              localStorage.setItem("priority", 2);
              localStorage.setItem("uid", JSON.stringify(data.result));
              setTimeout(() => {
                window.location = "/products"
              }, 2000)
              break
            default: break
          }
          
        } else {
          props.disableLoder()
          alert(data.msg)
        }
      })
      .catch(e => {
        props.disableLoder()
        console.log(e)
        alert(e.message)
      })
  }

  if (checkLocalStorage()) {
    window.location = "/dashboard"
    // return null
  }

  const handleChange = (event) => {
    setPersonName(event.target.value);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            // autoComplete="username"
            onChange={(e) => {
              // console.log(e.currentTarget.value);
              setUname(e.currentTarget.value)
            }}
          // autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            onChange={(e) => {
              // console.log(e.currentTarget.value);
              setPassword(e.currentTarget.value)
            }}
          // autoComplete="current-password"
          />
          <FormControl sx={{ width: 200, mt: "1em", mb: "0.5em" }}>
            <InputLabel id="demo-controlled-open-select-label">admin/provider</InputLabel>
            <Select
              labelId="demo-controlled-open-select-label"
              id="demo-controlled-open-select"
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              value={personName}
              label="select user"
              onChange={handleChange}
            >
              <MenuItem value={"admin"}>admin</MenuItem>
              {/* <MenuItem value={"provider"}>provider</MenuItem> */}
            </Select>
          </FormControl>
          {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
          <Loader />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={(e) => {
              switch (personName) {
                case "admin":
                  handlePost({
                    email: uname,
                    password: password
                  }, "/admin/login", personName)
                  break;
                case "provider":
                  handlePost({
                    email: uname,
                    password: password
                  }, "/providers/login", personName)
                  break;
                default: break
              }

            }}
          >
            Sign In
          </Button>
          <Grid container>
            <Grid item xs>
              <Link 
             href="/email_input" 
              variant="body2">
                Forgot password?
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default connect(mapStateToProps, mapDispachToProps)(Login)
